import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestPendingList = ({ pageNumber }) => {
  let getUrl = '/user/history/pending';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestShippedList = ({ pageNumber }) => {
  let getUrl = '/user/history/shipped';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};
const requestUndecidedList = ({ pageNumber }) => {
  let getUrl = '/user/history/undecided';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestPendingList,
  requestShippedList,
  requestUndecidedList,
};
